import { HTMLProps } from "react";

export const LoadingSpinner: React.FC<HTMLProps<HTMLDivElement>> = ({ className, ...rest }) => (
    <div className={`loadingSpinner ${className}`} {...rest}>
        <div className="spinner"></div>
    </div>
);
